/**
 * Kollektionsbeskrivelsen fylder en hel skaerm paa mobil, foer man naar
 * produkterne. Den foldes sammen med en "Laes mere"-knap, paa mobil efter
 * ca. 6 linjer og paa desktop efter 4.
 */
(function () {
  function start() {
    var tekst = document.querySelector('.nt-kollektion-tekst');
    if (!tekst) return;
    /* Foer kun mobil. Paa desktop gjorde lange tekster heroen 590 px hoej, og
       billedet blev strakt (Adam 14/9). CSS saetter hoejden pr. bredde. */
    if (tekst.scrollHeight <= tekst.clientHeight + 8) return;
    /* Toningen i bunden vises kun paa afkortet tekst (24/9) */
    tekst.classList.add('er-afkortet');

    var knap = document.createElement('button');
    knap.type = 'button';
    knap.className = 'nt-laes-mere';
    knap.textContent = tekst.dataset.mereTekst || 'Læs mere';
    knap.setAttribute('aria-expanded', 'false');
    tekst.insertAdjacentElement('afterend', knap);

    knap.addEventListener('click', function () {
      var aaben = tekst.classList.toggle('er-aaben');
      knap.setAttribute('aria-expanded', String(aaben));
      knap.textContent = aaben ? (tekst.dataset.mindreTekst || 'Læs mindre') : (tekst.dataset.mereTekst || 'Læs mere');
    });
  }
  /**
   * Produktantallet i toppen foelger filtrene.
   *
   * Filteret genrendrer kun produktsektionen, ikke banneret, saa forrubrikken
   * blev staaende paa 423 mens listen viste 210.
   *
   * Kilden er teksten paa filterdrawerens "Vis N resultater". Den er det
   * eneste sted tallet faktisk opdaterer sig: facet-filters.js saetter
   * closeBtn.innerText og roerer hverken attributter eller containerens
   * data-num-results.
   */
  function antalletFoelgerFiltrene() {
    var felt = document.querySelector('.collection-banner__count');
    var knap = document.querySelector('.js-close-drawer-mob');
    if (!felt || !knap) return;

    /* Etiketten kommer fra oversaettelsen. Banneret giver ental og flertal
       som data-felter ("1 produkt" og "2 produkter"), saa ordet passer til
       tallet, ogsaa naar et filter giver netop én vare (24/9). */
    var ental = felt.dataset.ental || '';
    var flertal = felt.dataset.flertal || felt.textContent.trim();
    if (!/[\d.,]+/.test(flertal)) return;

    function skriv() {
      var m = knap.innerText.match(/[\d.,]+/);
      if (!m) return;
      var tal = parseInt(m[0].replace(/[.,]/g, ''), 10);
      var skabelon = tal === 1 && ental ? ental : flertal;
      var nyTekst = skabelon.replace(/[\d.,]+/, m[0]);
      if (felt.textContent.trim() !== nyTekst) felt.textContent = nyTekst;
    }

    if (!window.MutationObserver) return;
    new MutationObserver(skriv).observe(knap, { childList: true, subtree: true, characterData: true });
    skriv();
  }

  function alt() {
    start();
    antalletFoelgerFiltrene();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', alt);
  } else {
    alt();
  }
})();
